





Splitting();


var s = Splitting();

// make follower follow - implified with quickTo

gsap.registerPlugin(ScrollTrigger);

locoScroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    reloadOnContextChange: true,
    smoothMobile: true,
    smartphone: {
        smooth: false,
        breakpoint: 767
    },
    tablet: {
        smooth: false,
       breakpoint: 1024
    },
    
});


$('.colleaction-switch .collection-list_1').owlCarousel({
  nav:true,
  loop:true,
  autoWidth:false,
  autoplay:true,
  slideTransition: 'linear',
  autoplayTimeout: 5000,
  autoplaySpeed: 5000,
  responsiveClass:true,
  responsive:{
      0:{
          items:4
      },
      600:{
          items:5,
          dots:true
      },
      1000:{
          items:10,
          margin:15,
          dots:false,
      }
  }
});

// locoScroll.on('scroll', (args) => {

//   // console.log('hi');

//   // Get all current elements : args.currentElements
//   if(typeof args.currentElements['hey'] === 'object') {
//       let progress = args.currentElements['hey'].progress;
//       console.log(progress);
//       if(progress > 0.1860882036572248){
//         $(".filter-wrap").addClass('fixed');
//       }else{
//         $(".filter-wrap").removeClass('fixed');
//       }
//       // ouput log example: 0.34
//       // gsap example : myGsapAnimation.progress(progress);
//   }
// });

// each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
locoScroll.on("scroll", ScrollTrigger.update);



// tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
ScrollTrigger.scrollerProxy("[data-scroll-container]", {
  scrollTop(value) {
    return arguments.length ? locoScroll.scrollTo(value, {duration: 0, disableLerp: true}) : locoScroll.scroll.instance.scroll.y;
  }, // we don't have to define a scrollLeft because we're only scrolling vertically.
  getBoundingClientRect() {
    return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
  },
  // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
  pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed"
});

// each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll. 
ScrollTrigger.addEventListener("refresh", () => locoScroll.update());
ScrollTrigger.defaults({ scroller: "[data-scroll-container]" });

gsap.set(".cursor", {xPercent: -50, yPercent: -50});

let xTo = gsap.quickTo(".cursor", "x", {duration: 0.6, ease: "power3"}),
    yTo = gsap.quickTo(".cursor", "y", {duration: 0.6, ease: "power3"});

let cursor = document.querySelector('.cursor');
let cursorScale = document.querySelectorAll('.banner-area');


window.addEventListener("mousemove", e => {
  xTo(e.clientX);
  yTo(e.clientY);
});

// locoScroll = new LocomotiveScroll({
//   el: document.querySelector("[data-scroll-container]"),
//   smooth: true,
// });
new ResizeObserver(() => locoScroll.update()).observe(
  document.querySelector("[data-scroll-container]")
);

//animate when passing over relevant objects
var followerText = document.querySelector('.follower__content');
let followerAnim = gsap.timeline({
	paused: true, 
	overwrite: 'auto',
	scrollTrigger:{
		scroller: '[data-scroll-container]'
	}
});

followerAnim.to('.follower__inner__bottom', {
  scale: 20,
  backgroundColor: 'transparent',
  duration: .15,
}, 0);
followerAnim.to('.follower__inner__top', {
  backgroundColor: 'transparent',
  scale: 20,
  opacity: 1,
  duration: .15,
}, 0.2);
followerAnim.to('.follower__content', {
  height: "32px",
});

document.querySelectorAll('.followerchangetest').forEach(item => {
  item.addEventListener('mouseenter', (event) => {
    var text = item.dataset.followerText;
    if (text == 0) {
      text = "Click";
    }
    followerText.innerHTML = text;
	cursor.classList.add('grow');

	if(item.classList.contains('home-fivth-section-inner')){
		cursor.classList.add('grow-2');
	}
    if(item.classList.contains('cutomCollectionPage')){
        cursor.classList.add('grow-2');
    }
    if(item.classList.contains('explore-black-cursor')){
      cursor.classList.add('grow-2');
  }
    animateFollower('in');
  });

  item.addEventListener('mouseleave', (event) => {
	cursor.classList.remove('grow');
	cursor.classList.remove('grow-2');
    animateFollower('out');
  });
});

function animateFollower(direction = 'in') {
  if (direction == 'in') {
    followerAnim.play().timeScale(1);
  } else {
    followerAnim.timeScale(-2);
  }
}


/*-- js for banner cursor  --*/




AOS.init({
      once: true,
      disable: function() { 
        var maxWidth = 800;
        return window.innerWidth > maxWidth;
        
      }
});






/*-- js for banner text animation --*/

const tl = gsap.timeline();

tl.from(".inner-content h2 strong", 1.8, {
  y: 200,
  ease: "power4.out",
  delay: 1,
  skewY: 7,
  stagger: {
    amount: 0.3
  }
});


const tl2 = gsap.timeline({
	scrollTrigger: {
		trigger: ".home-third-section-big-img", // make .panel2 the trigger
		scroller: '[data-scroll-container]'
	}
});

tl2.from(".home-third-section-big-img h2 span", 1.8, {
	y: 150,
	ease: "power4.out",
	delay: 1,
	skewY: 7,
	stagger: {
		amount: 0.3
	}
});

const tl3 = gsap.timeline({
	scrollTrigger: {
		trigger: ".home-fourth-section", // make .panel2 the trigger
		scroller: '[data-scroll-container]'
	}
});
tl3.from(".every-taste .block-box img", 1.8, {
	x: 100,
	ease: "power4.out",
	delay: 0,
	stagger: {
		amount: 0.3
	}
});




/*let Fixedheader = gsap.timeline({
  scrollTrigger: {
    scroller: '[data-scroll-container]',
    start: 'top -70',
    end: 99999,
    toggleClass: {className: 'header--scrolled', targets: '#mainHeader'}
  },
});*/


/*-- js for banner text animation --*/



/*---------------------------------------------------*/


/*------------------------------------------------*
      * Vars
      */
    this.menuBtn = document.querySelectorAll(".menu-btn");
    //this.menuHamburger = document.querySelector(".hamburger");
    this.changText = document.querySelector(".changetext");
    this.menu = document.querySelector(".menu");

    navTimeline = new TimelineMax({ paused: true });

    /**
     * Init
     */
    this.menuToggle();
    

    /**
     * Menu toggle
     */
    function menuToggle() {

      
        
        this.menuBtn.forEach( (menuToggler) => {

            let target = menuToggler.dataset.target;
            let navBg = document.querySelector(target).querySelectorAll('.menu__bg');
            let navInner = document.querySelector(target).querySelectorAll('.menu__links');
            let navLinks = document.querySelector(target).querySelectorAll('.menu__links__item');
            //let Menu = document.querySelector(".menu-wraper");
            let animationTime = 0.2;
            let easeIn = Circ.easeIn;
            let easeOut = Circ.easeOut;
            let easeInOut = Circ.easeInOut;
            let playState = true;
            navTimeline
                .fromTo(
                    target,
                    {
                        //top: '-100%',
                        //ease: easeIn
                    }, {
                        //top: '0%',
                        //ease: easeOut,
                        onReverseComplete: () => {
                            menuToggler.classList.remove('is-loading');
                        }
                    },
                    animationTime
                )
                .staggerTo(
                    navBg,
                    animationTime, {
                        //height: '100%',
                        //ease: easeInOut
                    },
                    0.1
                )
                .fromTo(
                    navInner,
                    animationTime, {
                        //top: '-100%',
                        //ease: easeIn
                    }, {
                        //top: '0%',
                        //ease: easeOut
                    }
                )
                .staggerFromTo(
                    navLinks,
                    animationTime, {
                        //y: '20%',
                        //opacity: 0,
                        //ease: Power4.easeOut
                    }, {
                        //y: '0%',
                        //opacity: 1,
                        //ease: Power4.easeOut
                    },
                    0.1
            );

          menuToggler.addEventListener('click', () => {

                menuToggler.classList.add('is-loading');
                
                
                

                if (playState) {
                    playState = false;
                    navTimeline.play().then( () => {
                        //this.menu.classList.add('is-loaded');
                        //menuToggler.classList.remove('is-loading');
                    });
                    //this.menuHamburger.classList.add('is-active');
                    this.changText.textContent = 'Close';
                    $(".weglot-container").addClass('position-relative');
                    //const audio = document.getElementById('engine-sound');
                    //console.log('play');
                    //audio.play();
                    //console.log('play over');
                    $(".menu-wraper").addClass("open");
                } else {
                    navTimeline.reverse();
                    playState = true;
                    this.menu.classList.remove('is-loaded');
                    //this.menuHamburger.classList.remove('is-active');
                    this.changText.textContent = 'Menu';
                    
                    $(".weglot-container").removeClass('position-relative');
                    $(".menu-wraper").removeClass("open");
                }
            });
        });
    }

    const slider= document.querySelector('#shopify-section-sections--18028676251896__footer_top_QDdHzw');
    const slider_two= document.querySelector('#shopify-section-template--18028675793144__home_second_section_aYAjAx');
    menuBtn = document.querySelectorAll(".menu-btn");
    $('.contact_link').on('click', function() {
      locoScroll.scrollTo(slider);
      navTimeline.reverse();
      document.querySelector(".changetext").textContent = 'Menu';
      menu.classList.remove('is-loaded');
      $(".menu-wraper").removeClass("open");
    });
    $('.about_link').on('click', function() {
      locoScroll.scrollTo(slider);
      navTimeline.reverse();
      document.querySelector(".changetext").textContent = 'Menu';
      menu.classList.remove('is-loaded');
    });


    menuToggle();



//const carsec = document.querySelector(".home-fivth-section .gallery__item");
const carsec = gsap.utils.toArray(".home-fivth-section .gallery__item");
const cmnImg = document.querySelector(".gallery__item-img");

function carSectionEntry(sec) {
   cmnImg.classList.add("open");
}
carsec.forEach((entrySection) => {
    ScrollTrigger.create({
      trigger: entrySection,
      start: "top 40",
      end: "bottom 40",
      onEnter: () => carSectionEntry(entrySection),
      //onEnterBack: () => carSectionEntry(entrySection),
    });
});


// Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

$(document).ready(function() {
	$('.accordion-panel').on('click', '.accordion__header', function() {
		$('.accordion__body').slideUp().removeClass('flipInX');
		$('.icon').removeClass('fa-minus');
		if($(this).next().is(':hidden')) {
			$(this).next().slideDown().addClass('flipInX');
			$(this).find('.icon').addClass('fa-minus');
		} else {
			$(this).next().slideUp();
			$(this).find('.icon').addClass('fa-plus');
		}
	});

  $('.filter-form').on('click', '.filter-group-summary', function() {
		$('.filter-group-display').slideUp();
    $(".filter-group-summary").removeClass('active');
		if($(this).next().is(':hidden')) {
			$(this).next().slideDown();
      $(this).addClass('active');
		} else {
			$(this).next().slideUp();
		}
	});

  $(window).click(function() {
    $(".filter-group-summary").removeClass('active');
    $('.filter-group-display').slideUp();
  });
  
  $('.filter-wrap').click(function(event){
    event.stopPropagation();
  });

  // $(".filter-group-display__list-item > label > input[type='radio']").click(function(){

  //   if($(this).is(':checked')){
  //     $(this).parent().addClass('selected');
  //   }else{
  //     // $(this).parent().removeClass('selected');
  //     alert("not checked");
  //   }

  // });

  // $('.collection_product_slider').owlCarousel({
  //     loop:true,
  //     margin:95,
  //     nav:true,
  //     dots:false,
  //     autoplay:true,
  //     autoplayTimeout:3000,
  //     autoplayHoverPause:true,
  //     responsiveClass:true,
  //     responsive:{
  //         0:{
  //             items:1
  //         },
  //         600:{
  //             items:2,
  //             margin:20,
  //         },
  //         1100:{
  //             items:3
  //         }
  //     }
  // });


  function postsCarousel() {
    var checkWidth = $(window).width();
    var owlPost = $(".collection_product_slider");
    if (checkWidth < 650) {
      if (typeof owlPost.data('owl.carousel') != 'undefined') {
        owlPost.data('owl.carousel').destroy();
      }
      owlPost.removeClass('owl-carousel');
    } else if (checkWidth > 768) {
      $('.product_row').removeClass('is_empty');
      owlPost.addClass('owl-carousel');
      owlPost.owlCarousel({
        loop:false,
        margin:95,
        nav:true,
        dots:false,
        // autoplay:true,
        // autoplayTimeout:3000,
        // autoplayHoverPause:true,
        responsiveClass:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1100:{
                items:2
            },
            1440:{
              items:3
            },
            2100:{
                items:4
            }
        }
      });
    }

    
  }
  
  postsCarousel();
  $(window).resize(postsCarousel);



  $('.listDesign').each(function() {
    //console.log('hello');
      if ($(this).find('.item').length == 0) {
        //console.log('hi');
        $(this).parent().parent().addClass('display-none');
      }
  });

  var checkWidth = $(window).width();
  if(checkWidth < 767){
    $('.contact_link').click(function(event) {
      event.preventDefault();
    $.scrollTo($('#shopify-section-sections--18028676251896__footer_top_QDdHzw'), 1000);
  });
  }
 


  $(".filter-trigger").click(function(){
    $(this).toggleClass('close');
    $(".filter-wrap").toggleClass('show');
  });

});

if( $('.photo-gallery').length )         // use this if you are using id to check
{
  const Shuffle = window.Shuffle;

  const myShuffle = new Shuffle(document.querySelector('.photo-gallery'), {
    itemSelector: '.picture-item',
    sizer: '.js-sizer',
    buffer: 1,
  });
}

var checkWidth = $(window).width();

if (checkWidth > 1201) {
  ScrollTrigger.create({
    trigger: '.filter-wrap',
    start: 'top top',
    endTrigger: 'footer',
    end: 'bottom+=100vh',
    toggleClass: { targets: ".filter-wrap", className: "fixed" },
    pin: true,
    pinReparent: true,
    pinSpacing: false
  });
}

ScrollTrigger.create({
  trigger: '.filter-trigger',
  start: 'top top',
  endTrigger: 'footer',
  end: 'bottom+=100vh',
  pin: true,
  // pinType: "fixed",
  markers: false,
  pinReparent: true,
  pinSpacing: false,
  zindex:100,
});

ScrollTrigger.create({
  trigger: '.main-header',
  start: 'top top',
  endTrigger: 'footer',
  end: 'bottom+=100vh',
  toggleClass: { targets: ".main-header", className: "has-color-bg" }
});

ScrollTrigger.create({
    trigger: '.enquire_button',
    start: 'top top',
    endTrigger: 'footer',
    end: 'bottom+=100vh',
    pin: true,
    pinType: "fixed",
    markers: false,
    pinReparent: true,
    pinSpacing: false
});

ScrollTrigger.create({
  trigger: '.form-popup',
  start: 'top top',
  endTrigger: 'footer',
  end: 'bottom+=100vh',
  pin: true,
  pinType: "fixed",
  markers: false,
  pinReparent: true,
  pinSpacing: false,
  //toggleClass: { targets: ".form-popup", className: "active" }
});

$(".enquire_button").click(function(){
    $(".form-popup").addClass('active');
    $(".form-popup").parent().addClass('active');
});
$(".close-popup").click(function(){
  $(".form-popup").removeClass('active');
});


// $('.product_row').each(function(i,obj) {
//   console.log($(this).find('.owl-stage').is(':empty'));
  
//   if($(this).find('.owl-stage').is(':empty')){
//     console.log($(this));
//   }
// });


// Function to trigger the loader animation and sound
// function playSoundAndLoader() {
//   const audio = document.getElementById('engine-sound');
//   const loaderLine = document.getElementById('loader-line');
  
//   // Play the sound
//   audio.play().then(() => {
//     // If the sound plays successfully, animate the loader line
//     loaderLine.style.width = '100%';

//     // Once the sound finishes, hide the loader line
//     audio.onended = function() {
//       loaderLine.style.display = 'none';
//     };
//   }).catch((error) => {
//     console.error('Audio playback failed:', error);
//   });
// }


// // Check if it's the first-time load using localStorage
// if (!localStorage.getItem('hasVisited')) {
//   // Set the flag that the user has visited
//   localStorage.setItem('hasVisited', 'true');
  
//   // Trigger the sound and loader on user interaction
//   window.onload = function() {
//     // Add an event listener to trigger sound and animation after any user interaction
//     document.body.addEventListener('click', playSoundAndLoader, { once: true });
//     document.body.addEventListener('keypress', playSoundAndLoader, { once: true });
//   };
// } else {
//   // If not the first-time load, skip the sound and loader
//   window.onload = function() {
//     const loaderLine = document.getElementById('loader-line');
//     loaderLine.style.display = 'none';
//   };
// }



